const municipios = [
    {
      id: "05001",
      municipio: "Medell\u00edn",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05002",
      municipio: "Abejorral",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05004",
      municipio: "Abriaqu\u00ed",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05021",
      municipio: "Alejandr\u00eda",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05030",
      municipio: "Amag\u00e1",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05031",
      municipio: "Amalfi",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05034",
      municipio: "Andes",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05036",
      municipio: "Angel\u00f3polis",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05038",
      municipio: "Angostura",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05040",
      municipio: "Anor\u00ed",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05042",
      municipio: "Santa F\u00e9 de Antioquia",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05044",
      municipio: "Anz\u00e1",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05045",
      municipio: "Apartad\u00f3",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05051",
      municipio: "Arboletes",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05055",
      municipio: "Argelia",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05059",
      municipio: "Armenia",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05079",
      municipio: "Barbosa",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05086",
      municipio: "Belmira",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05088",
      municipio: "Bello",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05091",
      municipio: "Betania",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05093",
      municipio: "Betulia",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05101",
      municipio: "Ciudad Bol\u00edvar",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05107",
      municipio: "Brice\u00f1o",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05113",
      municipio: "Buritic\u00e1",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05120",
      municipio: "C\u00e1ceres",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05125",
      municipio: "Caicedo",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05129",
      municipio: "Caldas",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05134",
      municipio: "Campamento",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05138",
      municipio: "Ca\u00f1asgordas",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05142",
      municipio: "Caracol\u00ed",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05145",
      municipio: "Caramanta",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05147",
      municipio: "Carepa",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05148",
      municipio: "El Carmen de Viboral",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05150",
      municipio: "Carolina",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05154",
      municipio: "Caucasia",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05172",
      municipio: "Chigorod\u00f3",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05190",
      municipio: "Cisneros",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05197",
      municipio: "Cocorn\u00e1",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05206",
      municipio: "Concepci\u00f3n",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05209",
      municipio: "Concordia",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05212",
      municipio: "Copacabana",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05234",
      municipio: "Dabeiba",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05237",
      municipio: "Donmat\u00edas",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05240",
      municipio: "Eb\u00e9jico",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05250",
      municipio: "El Bagre",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05264",
      municipio: "Entrerr\u00edos",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05266",
      municipio: "Envigado",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05282",
      municipio: "Fredonia",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05284",
      municipio: "Frontino",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05306",
      municipio: "Giraldo",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05308",
      municipio: "Girardota",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05310",
      municipio: "G\u00f3mez Plata",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05313",
      municipio: "Granada",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05315",
      municipio: "Guadalupe",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05318",
      municipio: "Guarne",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05321",
      municipio: "Guatap\u00e9",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05347",
      municipio: "Heliconia",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05353",
      municipio: "Hispania",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05360",
      municipio: "Itag\u00fc\u00ed",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05361",
      municipio: "Ituango",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05364",
      municipio: "Jard\u00edn",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05368",
      municipio: "Jeric\u00f3",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05376",
      municipio: "La Ceja",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05380",
      municipio: "La Estrella",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05390",
      municipio: "La Pintada",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05400",
      municipio: "La Uni\u00f3n",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05411",
      municipio: "Liborina",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05425",
      municipio: "Maceo",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05440",
      municipio: "Marinilla",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05467",
      municipio: "Montebello",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05475",
      municipio: "Murind\u00f3",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05480",
      municipio: "Mutat\u00e1",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05483",
      municipio: "Nari\u00f1o",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05490",
      municipio: "Necocl\u00ed",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05495",
      municipio: "Nech\u00ed",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05501",
      municipio: "Olaya",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05541",
      municipio: "Pe\u00f1ol",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05543",
      municipio: "Peque",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05576",
      municipio: "Pueblorrico",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05579",
      municipio: "Puerto Berr\u00edo",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05585",
      municipio: "Puerto Nare",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05591",
      municipio: "Puerto Triunfo",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05604",
      municipio: "Remedios",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05607",
      municipio: "Retiro",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05615",
      municipio: "Rionegro",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05628",
      municipio: "Sabanalarga",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05631",
      municipio: "Sabaneta",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05642",
      municipio: "Salgar",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05647",
      municipio: "San Andr\u00e9s de Cuerqu\u00eda",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05649",
      municipio: "San Carlos",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05652",
      municipio: "San Francisco",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05656",
      municipio: "San Jer\u00f3nimo",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05658",
      municipio: "San Jos\u00e9 la Monta\u00f1a",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05659",
      municipio: "San Juan de Urab\u00e1",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05660",
      municipio: "San Luis",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05664",
      municipio: "San Pedro los Milagros",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05665",
      municipio: "San Pedro de Urab\u00e1",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05667",
      municipio: "San Rafael",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05670",
      municipio: "San Roque",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05674",
      municipio: "San Vicente Ferrer",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05679",
      municipio: "Santa B\u00e1rbara",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05686",
      municipio: "Santa Rosa de Osos",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05690",
      municipio: "Santo Domingo",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05697",
      municipio: "El Santuario",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05736",
      municipio: "Segovia",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05756",
      municipio: "Sons\u00f3n",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05761",
      municipio: "Sopetr\u00e1n",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05789",
      municipio: "T\u00e1mesis",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05790",
      municipio: "Taraz\u00e1",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05792",
      municipio: "Tarso",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05809",
      municipio: "Titirib\u00ed",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05819",
      municipio: "Toledo",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05837",
      municipio: "Turbo",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05842",
      municipio: "Uramita",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05847",
      municipio: "Urrao",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05854",
      municipio: "Valdivia",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05856",
      municipio: "Valpara\u00edso",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05858",
      municipio: "Vegach\u00ed",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05861",
      municipio: "Venecia",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05873",
      municipio: "Vig\u00eda del Fuerte",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05885",
      municipio: "Yal\u00ed",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05887",
      municipio: "Yarumal",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05890",
      municipio: "Yolomb\u00f3",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05893",
      municipio: "Yond\u00f3",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "05895",
      municipio: "Zaragoza",
      id_departamento: "05",
      departamento: "Antioquia"
    },
    {
      id: "08001",
      municipio: "Barranquilla",
      id_departamento: "08",
      departamento: "Atl\u00e1ntico"
    },
    {
      id: "08078",
      municipio: "Baranoa",
      id_departamento: "08",
      departamento: "Atl\u00e1ntico"
    },
    {
      id: "08137",
      municipio: "Campo de la Cruz",
      id_departamento: "08",
      departamento: "Atl\u00e1ntico"
    },
    {
      id: "08141",
      municipio: "Candelaria",
      id_departamento: "08",
      departamento: "Atl\u00e1ntico"
    },
    {
      id: "08296",
      municipio: "Galapa",
      id_departamento: "08",
      departamento: "Atl\u00e1ntico"
    },
    {
      id: "08372",
      municipio: "Juan de Acosta",
      id_departamento: "08",
      departamento: "Atl\u00e1ntico"
    },
    {
      id: "08421",
      municipio: "Luruaco",
      id_departamento: "08",
      departamento: "Atl\u00e1ntico"
    },
    {
      id: "08433",
      municipio: "Malambo",
      id_departamento: "08",
      departamento: "Atl\u00e1ntico"
    },
    {
      id: "08436",
      municipio: "Manat\u00ed",
      id_departamento: "08",
      departamento: "Atl\u00e1ntico"
    },
    {
      id: "08520",
      municipio: "Palmar de Varela",
      id_departamento: "08",
      departamento: "Atl\u00e1ntico"
    },
    {
      id: "08549",
      municipio: "Pioj\u00f3",
      id_departamento: "08",
      departamento: "Atl\u00e1ntico"
    },
    {
      id: "08558",
      municipio: "Polonuevo",
      id_departamento: "08",
      departamento: "Atl\u00e1ntico"
    },
    {
      id: "08560",
      municipio: "Ponedera",
      id_departamento: "08",
      departamento: "Atl\u00e1ntico"
    },
    {
      id: "08573",
      municipio: "Puerto Colombia",
      id_departamento: "08",
      departamento: "Atl\u00e1ntico"
    },
    {
      id: "08606",
      municipio: "Repel\u00f3n",
      id_departamento: "08",
      departamento: "Atl\u00e1ntico"
    },
    {
      id: "08634",
      municipio: "Sabanagrande",
      id_departamento: "08",
      departamento: "Atl\u00e1ntico"
    },
    {
      id: "08638",
      municipio: "Sabanalarga",
      id_departamento: "08",
      departamento: "Atl\u00e1ntico"
    },
    {
      id: "08675",
      municipio: "Santa Luc\u00eda",
      id_departamento: "08",
      departamento: "Atl\u00e1ntico"
    },
    {
      id: "08685",
      municipio: "Santo Tom\u00e1s",
      id_departamento: "08",
      departamento: "Atl\u00e1ntico"
    },
    {
      id: "08758",
      municipio: "Soledad",
      id_departamento: "08",
      departamento: "Atl\u00e1ntico"
    },
    {
      id: "08770",
      municipio: "Suan",
      id_departamento: "08",
      departamento: "Atl\u00e1ntico"
    },
    {
      id: "08832",
      municipio: "Tubar\u00e1",
      id_departamento: "08",
      departamento: "Atl\u00e1ntico"
    },
    {
      id: "08849",
      municipio: "Usiacur\u00ed",
      id_departamento: "08",
      departamento: "Atl\u00e1ntico"
    },
    {
      id: "11001",
      municipio: "Bogot\u00e1 D.C.",
      id_departamento: "11",
      departamento: "Bogot\u00e1 Distrito Capital"
    },
    {
      id: "13001",
      municipio: "Cartagena de Indias",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13006",
      municipio: "Ach\u00ed",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13030",
      municipio: "Altos del Rosario",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13042",
      municipio: "Arenal",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13052",
      municipio: "Arjona",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13062",
      municipio: "Arroyohondo",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13074",
      municipio: "Barranco de Loba",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13140",
      municipio: "Calamar",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13160",
      municipio: "Cantagallo",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13188",
      municipio: "Cicuco",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13212",
      municipio: "C\u00f3rdoba",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13222",
      municipio: "Clemencia",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13244",
      municipio: "El Carmen de Bol\u00edvar",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13248",
      municipio: "El Guamo",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13268",
      municipio: "El Pe\u00f1\u00f3n",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13300",
      municipio: "Hatillo de Loba",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13430",
      municipio: "Magangu\u00e9",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13433",
      municipio: "Mahates",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13440",
      municipio: "Margarita",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13442",
      municipio: "Mar\u00eda la Baja",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13458",
      municipio: "Montecristo",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13468",
      municipio: "Momp\u00f3s",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13473",
      municipio: "Morales",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13490",
      municipio: "Noros\u00ed",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13549",
      municipio: "Pinillos",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13580",
      municipio: "Regidor",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13600",
      municipio: "R\u00edo Viejo",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13620",
      municipio: "San Crist\u00f3bal",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13647",
      municipio: "San Estanislao",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13650",
      municipio: "San Fernando",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13654",
      municipio: "San Jacinto",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13655",
      municipio: "San Jacinto del Cauca",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13657",
      municipio: "San Juan Nepomuceno",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13667",
      municipio: "San Mart\u00edn de Loba",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13670",
      municipio: "San Pablo",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13673",
      municipio: "Santa Catalina",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13683",
      municipio: "Santa Rosa",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13688",
      municipio: "Santa Rosa del Sur",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13744",
      municipio: "Simit\u00ed",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13760",
      municipio: "Soplaviento",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13780",
      municipio: "Talaigua Nuevo",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13810",
      municipio: "Tiquisio",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13836",
      municipio: "Turbaco",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13838",
      municipio: "Turban\u00e1",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13873",
      municipio: "Villanueva",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "13894",
      municipio: "Zambrano",
      id_departamento: "13",
      departamento: "Bol\u00edvar"
    },
    {
      id: "15001",
      municipio: "Tunja",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15022",
      municipio: "Almeida",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15047",
      municipio: "Aquitania",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15051",
      municipio: "Arcabuco",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15087",
      municipio: "Bel\u00e9n",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15090",
      municipio: "Berbeo",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15092",
      municipio: "Bet\u00e9itiva",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15097",
      municipio: "Boavita",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15104",
      municipio: "Boyac\u00e1",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15106",
      municipio: "Brice\u00f1o",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15109",
      municipio: "Buenavista",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15114",
      municipio: "Busbanz\u00e1",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15131",
      municipio: "Caldas",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15135",
      municipio: "Campohermoso",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15162",
      municipio: "Cerinza",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15172",
      municipio: "Chinavita",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15176",
      municipio: "Chiquinquir\u00e1",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15180",
      municipio: "Chiscas",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15183",
      municipio: "Chita",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15185",
      municipio: "Chitaraque",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15187",
      municipio: "Chivat\u00e1",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15189",
      municipio: "Ci\u00e9nega",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15204",
      municipio: "C\u00f3mbita",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15212",
      municipio: "Coper",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15215",
      municipio: "Corrales",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15218",
      municipio: "Covarach\u00eda",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15223",
      municipio: "Cubar\u00e1",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15224",
      municipio: "Cucaita",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15226",
      municipio: "Cu\u00edtiva",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15232",
      municipio: "Ch\u00edquiza",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15236",
      municipio: "Chivor",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15238",
      municipio: "Duitama",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15244",
      municipio: "El Cocuy",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15248",
      municipio: "El Espino",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15272",
      municipio: "Firavitoba",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15276",
      municipio: "Floresta",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15293",
      municipio: "Gachantiv\u00e1",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15296",
      municipio: "G\u00e1meza",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15299",
      municipio: "Garagoa",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15317",
      municipio: "Guacamayas",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15322",
      municipio: "Guateque",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15325",
      municipio: "Guayat\u00e1",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15332",
      municipio: "G\u00fcic\u00e1n",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15362",
      municipio: "Iza",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15367",
      municipio: "Jenesano",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15368",
      municipio: "Jeric\u00f3",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15377",
      municipio: "Labranzagrande",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15380",
      municipio: "La Capilla",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15401",
      municipio: "La Victoria",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15403",
      municipio: "La Uvita",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15407",
      municipio: "Villa de Leyva",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15425",
      municipio: "Macanal",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15442",
      municipio: "Marip\u00ed",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15455",
      municipio: "Miraflores",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15464",
      municipio: "Mongua",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15466",
      municipio: "Mongu\u00ed",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15469",
      municipio: "Moniquir\u00e1",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15476",
      municipio: "Motavita",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15480",
      municipio: "Muzo",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15491",
      municipio: "Nobsa",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15494",
      municipio: "Nuevo Col\u00f3n",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15500",
      municipio: "Oicat\u00e1",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15507",
      municipio: "Otanche",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15511",
      municipio: "Pachavita",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15514",
      municipio: "P\u00e1ez",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15516",
      municipio: "Paipa",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15518",
      municipio: "Pajarito",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15522",
      municipio: "Panqueba",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15531",
      municipio: "Pauna",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15533",
      municipio: "Paya",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15537",
      municipio: "Paz de R\u00edo",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15542",
      municipio: "Pesca",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15550",
      municipio: "Pisba",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15572",
      municipio: "Puerto Boyac\u00e1",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15580",
      municipio: "Qu\u00edpama",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15599",
      municipio: "Ramiriqu\u00ed",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15600",
      municipio: "R\u00e1quira",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15621",
      municipio: "Rond\u00f3n",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15632",
      municipio: "Saboy\u00e1",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15638",
      municipio: "S\u00e1chica",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15646",
      municipio: "Samac\u00e1",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15660",
      municipio: "San Eduardo",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15664",
      municipio: "San Jos\u00e9 de Pare",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15667",
      municipio: "San Luis de Gaceno",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15673",
      municipio: "San Mateo",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15676",
      municipio: "San Miguel de Sema",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15681",
      municipio: "San Pablo de Borbur",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15686",
      municipio: "Santana",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15690",
      municipio: "Santa Mar\u00eda",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15693",
      municipio: "Santa Rosa de Viterbo",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15696",
      municipio: "Santa Sof\u00eda",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15720",
      municipio: "Sativanorte",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15723",
      municipio: "Sativasur",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15740",
      municipio: "Siachoque",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15753",
      municipio: "Soat\u00e1",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15755",
      municipio: "Socot\u00e1",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15757",
      municipio: "Socha",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15759",
      municipio: "Sogamoso",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15761",
      municipio: "Somondoco",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15762",
      municipio: "Sora",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15763",
      municipio: "Sotaquir\u00e1",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15764",
      municipio: "Sorac\u00e1",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15774",
      municipio: "Susac\u00f3n",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15776",
      municipio: "Sutamarch\u00e1n",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15778",
      municipio: "Sutatenza",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15790",
      municipio: "Tasco",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15798",
      municipio: "Tenza",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15804",
      municipio: "Tiban\u00e1",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15806",
      municipio: "Tibasosa",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15808",
      municipio: "Tinjac\u00e1",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15810",
      municipio: "Tipacoque",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15814",
      municipio: "Toca",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15816",
      municipio: "Tog\u00fc\u00ed",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15820",
      municipio: "T\u00f3paga",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15822",
      municipio: "Tota",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15832",
      municipio: "Tunungu\u00e1",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15835",
      municipio: "Turmequ\u00e9",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15837",
      municipio: "Tuta",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15839",
      municipio: "Tutaz\u00e1",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15842",
      municipio: "\u00dambita",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15861",
      municipio: "Ventaquemada",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15879",
      municipio: "Viracach\u00e1",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "15897",
      municipio: "Zetaquira",
      id_departamento: "15",
      departamento: "Boyac\u00e1"
    },
    {
      id: "17001",
      municipio: "Manizales",
      id_departamento: "17",
      departamento: "Caldas"
    },
    {
      id: "17013",
      municipio: "Aguadas",
      id_departamento: "17",
      departamento: "Caldas"
    },
    {
      id: "17042",
      municipio: "Anserma",
      id_departamento: "17",
      departamento: "Caldas"
    },
    {
      id: "17050",
      municipio: "Aranzazu",
      id_departamento: "17",
      departamento: "Caldas"
    },
    {
      id: "17088",
      municipio: "Belalc\u00e1zar",
      id_departamento: "17",
      departamento: "Caldas"
    },
    {
      id: "17174",
      municipio: "Chinchin\u00e1",
      id_departamento: "17",
      departamento: "Caldas"
    },
    {
      id: "17272",
      municipio: "Filadelfia",
      id_departamento: "17",
      departamento: "Caldas"
    },
    {
      id: "17380",
      municipio: "La Dorada",
      id_departamento: "17",
      departamento: "Caldas"
    },
    {
      id: "17388",
      municipio: "La Merced",
      id_departamento: "17",
      departamento: "Caldas"
    },
    {
      id: "17433",
      municipio: "Manzanares",
      id_departamento: "17",
      departamento: "Caldas"
    },
    {
      id: "17442",
      municipio: "Marmato",
      id_departamento: "17",
      departamento: "Caldas"
    },
    {
      id: "17444",
      municipio: "Marquetalia",
      id_departamento: "17",
      departamento: "Caldas"
    },
    {
      id: "17446",
      municipio: "Marulanda",
      id_departamento: "17",
      departamento: "Caldas"
    },
    {
      id: "17486",
      municipio: "Neira",
      id_departamento: "17",
      departamento: "Caldas"
    },
    {
      id: "17495",
      municipio: "Norcasia",
      id_departamento: "17",
      departamento: "Caldas"
    },
    {
      id: "17513",
      municipio: "P\u00e1cora",
      id_departamento: "17",
      departamento: "Caldas"
    },
    {
      id: "17524",
      municipio: "Palestina",
      id_departamento: "17",
      departamento: "Caldas"
    },
    {
      id: "17541",
      municipio: "Pensilvania",
      id_departamento: "17",
      departamento: "Caldas"
    },
    {
      id: "17614",
      municipio: "Riosucio",
      id_departamento: "17",
      departamento: "Caldas"
    },
    {
      id: "17616",
      municipio: "Risaralda",
      id_departamento: "17",
      departamento: "Caldas"
    },
    {
      id: "17653",
      municipio: "Salamina",
      id_departamento: "17",
      departamento: "Caldas"
    },
    {
      id: "17662",
      municipio: "Saman\u00e1",
      id_departamento: "17",
      departamento: "Caldas"
    },
    {
      id: "17665",
      municipio: "San Jos\u00e9",
      id_departamento: "17",
      departamento: "Caldas"
    },
    {
      id: "17777",
      municipio: "Sup\u00eda",
      id_departamento: "17",
      departamento: "Caldas"
    },
    {
      id: "17867",
      municipio: "Victoria",
      id_departamento: "17",
      departamento: "Caldas"
    },
    {
      id: "17873",
      municipio: "Villamar\u00eda",
      id_departamento: "17",
      departamento: "Caldas"
    },
    {
      id: "17877",
      municipio: "Viterbo",
      id_departamento: "17",
      departamento: "Caldas"
    },
    {
      id: "18001",
      municipio: "Florencia",
      id_departamento: "18",
      departamento: "Caquet\u00e1"
    },
    {
      id: "18029",
      municipio: "Albania",
      id_departamento: "18",
      departamento: "Caquet\u00e1"
    },
    {
      id: "18094",
      municipio: "Bel\u00e9n de los Andaqu\u00edes",
      id_departamento: "18",
      departamento: "Caquet\u00e1"
    },
    {
      id: "18150",
      municipio: "Cartagena del Chair\u00e1",
      id_departamento: "18",
      departamento: "Caquet\u00e1"
    },
    {
      id: "18205",
      municipio: "Curillo",
      id_departamento: "18",
      departamento: "Caquet\u00e1"
    },
    {
      id: "18247",
      municipio: "El Doncello",
      id_departamento: "18",
      departamento: "Caquet\u00e1"
    },
    {
      id: "18256",
      municipio: "El Pauj\u00edl",
      id_departamento: "18",
      departamento: "Caquet\u00e1"
    },
    {
      id: "18410",
      municipio: "La Monta\u00f1ita",
      id_departamento: "18",
      departamento: "Caquet\u00e1"
    },
    {
      id: "18460",
      municipio: "Mil\u00e1n",
      id_departamento: "18",
      departamento: "Caquet\u00e1"
    },
    {
      id: "18479",
      municipio: "Morelia",
      id_departamento: "18",
      departamento: "Caquet\u00e1"
    },
    {
      id: "18592",
      municipio: "Puerto Rico",
      id_departamento: "18",
      departamento: "Caquet\u00e1"
    },
    {
      id: "18610",
      municipio: "San Jos\u00e9 del Fragua",
      id_departamento: "18",
      departamento: "Caquet\u00e1"
    },
    {
      id: "18753",
      municipio: "San Vicente del Cagu\u00e1n",
      id_departamento: "18",
      departamento: "Caquet\u00e1"
    },
    {
      id: "18756",
      municipio: "Solano",
      id_departamento: "18",
      departamento: "Caquet\u00e1"
    },
    {
      id: "18785",
      municipio: "Solita",
      id_departamento: "18",
      departamento: "Caquet\u00e1"
    },
    {
      id: "18860",
      municipio: "Valpara\u00edso",
      id_departamento: "18",
      departamento: "Caquet\u00e1"
    },
    {
      id: "19001",
      municipio: "Popay\u00e1n",
      id_departamento: "19",
      departamento: "Cauca"
    },
    {
      id: "19022",
      municipio: "Almaguer",
      id_departamento: "19",
      departamento: "Cauca"
    },
    {
      id: "19050",
      municipio: "Argelia",
      id_departamento: "19",
      departamento: "Cauca"
    },
    {
      id: "19075",
      municipio: "Balboa",
      id_departamento: "19",
      departamento: "Cauca"
    },
    {
      id: "19100",
      municipio: "Bol\u00edvar",
      id_departamento: "19",
      departamento: "Cauca"
    },
    {
      id: "19110",
      municipio: "Buenos Aires",
      id_departamento: "19",
      departamento: "Cauca"
    },
    {
      id: "19130",
      municipio: "Cajib\u00edo",
      id_departamento: "19",
      departamento: "Cauca"
    },
    {
      id: "19137",
      municipio: "Caldono",
      id_departamento: "19",
      departamento: "Cauca"
    },
    {
      id: "19142",
      municipio: "Caloto",
      id_departamento: "19",
      departamento: "Cauca"
    },
    {
      id: "19212",
      municipio: "Corinto",
      id_departamento: "19",
      departamento: "Cauca"
    },
    {
      id: "19256",
      municipio: "El Tambo",
      id_departamento: "19",
      departamento: "Cauca"
    },
    {
      id: "19290",
      municipio: "Florencia",
      id_departamento: "19",
      departamento: "Cauca"
    },
    {
      id: "19300",
      municipio: "Guachen\u00e9",
      id_departamento: "19",
      departamento: "Cauca"
    },
    {
      id: "19318",
      municipio: "Guap\u00ed",
      id_departamento: "19",
      departamento: "Cauca"
    },
    {
      id: "19355",
      municipio: "Inz\u00e1",
      id_departamento: "19",
      departamento: "Cauca"
    },
    {
      id: "19364",
      municipio: "Jambal\u00f3",
      id_departamento: "19",
      departamento: "Cauca"
    },
    {
      id: "19392",
      municipio: "La Sierra",
      id_departamento: "19",
      departamento: "Cauca"
    },
    {
      id: "19397",
      municipio: "La Vega",
      id_departamento: "19",
      departamento: "Cauca"
    },
    {
      id: "19418",
      municipio: "L\u00f3pez de Micay",
      id_departamento: "19",
      departamento: "Cauca"
    },
    {
      id: "19450",
      municipio: "Mercaderes",
      id_departamento: "19",
      departamento: "Cauca"
    },
    {
      id: "19455",
      municipio: "Miranda",
      id_departamento: "19",
      departamento: "Cauca"
    },
    {
      id: "19473",
      municipio: "Morales",
      id_departamento: "19",
      departamento: "Cauca"
    },
    {
      id: "19513",
      municipio: "Padilla",
      id_departamento: "19",
      departamento: "Cauca"
    },
    {
      id: "19517",
      municipio: "P\u00e1ez",
      id_departamento: "19",
      departamento: "Cauca"
    },
    {
      id: "19532",
      municipio: "Pat\u00eda",
      id_departamento: "19",
      departamento: "Cauca"
    },
    {
      id: "19533",
      municipio: "Piamonte",
      id_departamento: "19",
      departamento: "Cauca"
    },
    {
      id: "19548",
      municipio: "Piendam\u00f3",
      id_departamento: "19",
      departamento: "Cauca"
    },
    {
      id: "19573",
      municipio: "Puerto Tejada",
      id_departamento: "19",
      departamento: "Cauca"
    },
    {
      id: "19585",
      municipio: "Purac\u00e9",
      id_departamento: "19",
      departamento: "Cauca"
    },
    {
      id: "19622",
      municipio: "Rosas",
      id_departamento: "19",
      departamento: "Cauca"
    },
    {
      id: "19693",
      municipio: "San Sebasti\u00e1n",
      id_departamento: "19",
      departamento: "Cauca"
    },
    {
      id: "19698",
      municipio: "Santander de Quilichao",
      id_departamento: "19",
      departamento: "Cauca"
    },
    {
      id: "19701",
      municipio: "Santa Rosa",
      id_departamento: "19",
      departamento: "Cauca"
    },
    {
      id: "19743",
      municipio: "Silvia",
      id_departamento: "19",
      departamento: "Cauca"
    },
    {
      id: "19760",
      municipio: "Sotara",
      id_departamento: "19",
      departamento: "Cauca"
    },
    {
      id: "19780",
      municipio: "Su\u00e1rez",
      id_departamento: "19",
      departamento: "Cauca"
    },
    {
      id: "19785",
      municipio: "Sucre",
      id_departamento: "19",
      departamento: "Cauca"
    },
    {
      id: "19807",
      municipio: "Timb\u00edo",
      id_departamento: "19",
      departamento: "Cauca"
    },
    {
      id: "19809",
      municipio: "Timbiqu\u00ed",
      id_departamento: "19",
      departamento: "Cauca"
    },
    {
      id: "19821",
      municipio: "Torib\u00edo",
      id_departamento: "19",
      departamento: "Cauca"
    },
    {
      id: "19824",
      municipio: "Totor\u00f3",
      id_departamento: "19",
      departamento: "Cauca"
    },
    {
      id: "19845",
      municipio: "Villa rica",
      id_departamento: "19",
      departamento: "Cauca"
    },
    {
      id: "20001",
      municipio: "Valledupar",
      id_departamento: "20",
      departamento: "Cesar"
    },
    {
      id: "20011",
      municipio: "Aguachica",
      id_departamento: "20",
      departamento: "Cesar"
    },
    {
      id: "20013",
      municipio: "Agust\u00edn Codazzi",
      id_departamento: "20",
      departamento: "Cesar"
    },
    {
      id: "20032",
      municipio: "Astrea",
      id_departamento: "20",
      departamento: "Cesar"
    },
    {
      id: "20045",
      municipio: "Becerril",
      id_departamento: "20",
      departamento: "Cesar"
    },
    {
      id: "20060",
      municipio: "Bosconia",
      id_departamento: "20",
      departamento: "Cesar"
    },
    {
      id: "20175",
      municipio: "Chimichagua",
      id_departamento: "20",
      departamento: "Cesar"
    },
    {
      id: "20178",
      municipio: "Chiriguan\u00e1",
      id_departamento: "20",
      departamento: "Cesar"
    },
    {
      id: "20228",
      municipio: "Curuman\u00ed",
      id_departamento: "20",
      departamento: "Cesar"
    },
    {
      id: "20238",
      municipio: "El Copey",
      id_departamento: "20",
      departamento: "Cesar"
    },
    {
      id: "20250",
      municipio: "El Paso",
      id_departamento: "20",
      departamento: "Cesar"
    },
    {
      id: "20295",
      municipio: "Gamarra",
      id_departamento: "20",
      departamento: "Cesar"
    },
    {
      id: "20310",
      municipio: "Gonz\u00e1lez",
      id_departamento: "20",
      departamento: "Cesar"
    },
    {
      id: "20383",
      municipio: "La Gloria",
      id_departamento: "20",
      departamento: "Cesar"
    },
    {
      id: "20400",
      municipio: "La Jagua de Ibirico",
      id_departamento: "20",
      departamento: "Cesar"
    },
    {
      id: "20443",
      municipio: "Manaure Balc\u00f3n del Cesar",
      id_departamento: "20",
      departamento: "Cesar"
    },
    {
      id: "20517",
      municipio: "Pailitas",
      id_departamento: "20",
      departamento: "Cesar"
    },
    {
      id: "20550",
      municipio: "Pelaya",
      id_departamento: "20",
      departamento: "Cesar"
    },
    {
      id: "20570",
      municipio: "Pueblo Bello",
      id_departamento: "20",
      departamento: "Cesar"
    },
    {
      id: "20614",
      municipio: "R\u00edo de Oro",
      id_departamento: "20",
      departamento: "Cesar"
    },
    {
      id: "20621",
      municipio: "La Paz",
      id_departamento: "20",
      departamento: "Cesar"
    },
    {
      id: "20710",
      municipio: "San Alberto",
      id_departamento: "20",
      departamento: "Cesar"
    },
    {
      id: "20750",
      municipio: "San Diego",
      id_departamento: "20",
      departamento: "Cesar"
    },
    {
      id: "20770",
      municipio: "San Mart\u00edn",
      id_departamento: "20",
      departamento: "Cesar"
    },
    {
      id: "20787",
      municipio: "Tamalameque",
      id_departamento: "20",
      departamento: "Cesar"
    },
    {
      id: "23001",
      municipio: "Monter\u00eda",
      id_departamento: "23",
      departamento: "C\u00f3rdoba"
    },
    {
      id: "23068",
      municipio: "Ayapel",
      id_departamento: "23",
      departamento: "C\u00f3rdoba"
    },
    {
      id: "23079",
      municipio: "Buenavista",
      id_departamento: "23",
      departamento: "C\u00f3rdoba"
    },
    {
      id: "23090",
      municipio: "Canalete",
      id_departamento: "23",
      departamento: "C\u00f3rdoba"
    },
    {
      id: "23162",
      municipio: "Ceret\u00e9",
      id_departamento: "23",
      departamento: "C\u00f3rdoba"
    },
    {
      id: "23168",
      municipio: "Chim\u00e1",
      id_departamento: "23",
      departamento: "C\u00f3rdoba"
    },
    {
      id: "23182",
      municipio: "Chin\u00fa",
      id_departamento: "23",
      departamento: "C\u00f3rdoba"
    },
    {
      id: "23189",
      municipio: "Ci\u00e9naga de Oro",
      id_departamento: "23",
      departamento: "C\u00f3rdoba"
    },
    {
      id: "23300",
      municipio: "Cotorra",
      id_departamento: "23",
      departamento: "C\u00f3rdoba"
    },
    {
      id: "23350",
      municipio: "La Apartada",
      id_departamento: "23",
      departamento: "C\u00f3rdoba"
    },
    {
      id: "23417",
      municipio: "Lorica",
      id_departamento: "23",
      departamento: "C\u00f3rdoba"
    },
    {
      id: "23419",
      municipio: "Los C\u00f3rdobas",
      id_departamento: "23",
      departamento: "C\u00f3rdoba"
    },
    {
      id: "23464",
      municipio: "Momil",
      id_departamento: "23",
      departamento: "C\u00f3rdoba"
    },
    {
      id: "23466",
      municipio: "Montel\u00edbano",
      id_departamento: "23",
      departamento: "C\u00f3rdoba"
    },
    {
      id: "23500",
      municipio: "Mo\u00f1itos",
      id_departamento: "23",
      departamento: "C\u00f3rdoba"
    },
    {
      id: "23555",
      municipio: "Planeta Rica",
      id_departamento: "23",
      departamento: "C\u00f3rdoba"
    },
    {
      id: "23570",
      municipio: "Pueblo Nuevo",
      id_departamento: "23",
      departamento: "C\u00f3rdoba"
    },
    {
      id: "23574",
      municipio: "Puerto Escondido",
      id_departamento: "23",
      departamento: "C\u00f3rdoba"
    },
    {
      id: "23580",
      municipio: "Puerto Libertador",
      id_departamento: "23",
      departamento: "C\u00f3rdoba"
    },
    {
      id: "23586",
      municipio: "Pur\u00edsima de la Concepci\u00f3n",
      id_departamento: "23",
      departamento: "C\u00f3rdoba"
    },
    {
      id: "23660",
      municipio: "Sahag\u00fan",
      id_departamento: "23",
      departamento: "C\u00f3rdoba"
    },
    {
      id: "23670",
      municipio: "San Andr\u00e9s de Sotavento",
      id_departamento: "23",
      departamento: "C\u00f3rdoba"
    },
    {
      id: "23672",
      municipio: "San Antero",
      id_departamento: "23",
      departamento: "C\u00f3rdoba"
    },
    {
      id: "23675",
      municipio: "San Bernardo del Viento",
      id_departamento: "23",
      departamento: "C\u00f3rdoba"
    },
    {
      id: "23678",
      municipio: "San Carlos",
      id_departamento: "23",
      departamento: "C\u00f3rdoba"
    },
    {
      id: "23682",
      municipio: "San Jos\u00e9 de Ur\u00e9",
      id_departamento: "23",
      departamento: "C\u00f3rdoba"
    },
    {
      id: "23686",
      municipio: "San Pelayo",
      id_departamento: "23",
      departamento: "C\u00f3rdoba"
    },
    {
      id: "23807",
      municipio: "Tierralta",
      id_departamento: "23",
      departamento: "C\u00f3rdoba"
    },
    {
      id: "23815",
      municipio: "Tuch\u00edn",
      id_departamento: "23",
      departamento: "C\u00f3rdoba"
    },
    {
      id: "23855",
      municipio: "Valencia",
      id_departamento: "23",
      departamento: "C\u00f3rdoba"
    },
    {
      id: "25001",
      municipio: "Agua de Dios",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25019",
      municipio: "Alb\u00e1n",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25035",
      municipio: "Anapoima",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25040",
      municipio: "Anolaima",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25053",
      municipio: "Arbel\u00e1ez",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25086",
      municipio: "Beltr\u00e1n",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25095",
      municipio: "Bituima",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25099",
      municipio: "Bojac\u00e1",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25120",
      municipio: "Cabrera",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25123",
      municipio: "Cachipay",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25126",
      municipio: "Cajic\u00e1",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25148",
      municipio: "Caparrap\u00ed",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25151",
      municipio: "C\u00e1queza",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25154",
      municipio: "Carmen de Carupa",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25168",
      municipio: "Chaguan\u00ed",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25175",
      municipio: "Ch\u00eda",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25178",
      municipio: "Chipaque",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25181",
      municipio: "Choach\u00ed",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25183",
      municipio: "Chocont\u00e1",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25200",
      municipio: "Cogua",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25214",
      municipio: "Cota",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25224",
      municipio: "Cucunub\u00e1",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25245",
      municipio: "El Colegio",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25258",
      municipio: "El Pe\u00f1\u00f3n",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25260",
      municipio: "El Rosal",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25269",
      municipio: "Facatativ\u00e1",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25279",
      municipio: "F\u00f3meque",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25281",
      municipio: "Fosca",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25286",
      municipio: "Funza",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25288",
      municipio: "F\u00faquene",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25290",
      municipio: "Fusagasug\u00e1",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25293",
      municipio: "Gachal\u00e1",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25295",
      municipio: "Gachancip\u00e1",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25297",
      municipio: "Gachet\u00e1",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25299",
      municipio: "Gama",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25307",
      municipio: "Girardot",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25312",
      municipio: "Granada",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25317",
      municipio: "Guachet\u00e1",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25320",
      municipio: "Guaduas",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25322",
      municipio: "Guasca",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25324",
      municipio: "Guataqu\u00ed",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25326",
      municipio: "Guatavita",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25328",
      municipio: "Guayabal de S\u00edquima",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25335",
      municipio: "Guayabetal",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25339",
      municipio: "Guti\u00e9rrez",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25368",
      municipio: "Jerusal\u00e9n",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25372",
      municipio: "Jun\u00edn",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25377",
      municipio: "La Calera",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25386",
      municipio: "La Mesa",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25394",
      municipio: "La Palma",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25398",
      municipio: "La Pe\u00f1a",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25402",
      municipio: "La Vega",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25407",
      municipio: "Lenguazaque",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25426",
      municipio: "Machet\u00e1",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25430",
      municipio: "Madrid",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25436",
      municipio: "Manta",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25438",
      municipio: "Medina",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25473",
      municipio: "Mosquera",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25483",
      municipio: "Nari\u00f1o",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25486",
      municipio: "Nemoc\u00f3n",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25488",
      municipio: "Nilo",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25489",
      municipio: "Nimaima",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25491",
      municipio: "Nocaima",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25506",
      municipio: "Venecia",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25513",
      municipio: "Pacho",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25518",
      municipio: "Paime",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25524",
      municipio: "Pandi",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25530",
      municipio: "Paratebueno",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25535",
      municipio: "Pasca",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25572",
      municipio: "Puerto Salgar",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25580",
      municipio: "Pul\u00ed",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25592",
      municipio: "Quebradanegra",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25594",
      municipio: "Quetame",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25596",
      municipio: "Quipile",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25599",
      municipio: "Apulo",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25612",
      municipio: "Ricaurte",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25645",
      municipio: "San Antonio del Tequendama",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25649",
      municipio: "San Bernardo",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25653",
      municipio: "San Cayetano",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25658",
      municipio: "San Francisco",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25662",
      municipio: "San Juan de Rioseco",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25718",
      municipio: "Sasaima",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25736",
      municipio: "Sesquil\u00e9",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25740",
      municipio: "Sibat\u00e9",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25743",
      municipio: "Silvania",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25745",
      municipio: "Simijaca",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25754",
      municipio: "Soacha",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25758",
      municipio: "Sop\u00f3",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25769",
      municipio: "Subachoque",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25772",
      municipio: "Suesca",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25777",
      municipio: "Supat\u00e1",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25779",
      municipio: "Susa",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25781",
      municipio: "Sutatausa",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25785",
      municipio: "Tabio",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25793",
      municipio: "Tausa",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25797",
      municipio: "Tena",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25799",
      municipio: "Tenjo",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25805",
      municipio: "Tibacuy",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25807",
      municipio: "Tibirita",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25815",
      municipio: "Tocaima",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25817",
      municipio: "Tocancip\u00e1",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25823",
      municipio: "Topaip\u00ed",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25839",
      municipio: "Ubal\u00e1",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25841",
      municipio: "Ubaque",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25843",
      municipio: "Villa de de Ubat\u00e9",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25845",
      municipio: "Une",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25851",
      municipio: "\u00datica",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25862",
      municipio: "Vergara",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25867",
      municipio: "Vian\u00ed",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25871",
      municipio: "Villag\u00f3mez",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25873",
      municipio: "Villapinz\u00f3n",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25875",
      municipio: "Villeta",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25878",
      municipio: "Viot\u00e1",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25885",
      municipio: "Yacop\u00ed",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25898",
      municipio: "Zipac\u00f3n",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "25899",
      municipio: "Zipaquir\u00e1",
      id_departamento: "25",
      departamento: "Cundinamarca"
    },
    {
      id: "27001",
      municipio: "Quibd\u00f3",
      id_departamento: "27",
      departamento: "Choc\u00f3"
    },
    {
      id: "27006",
      municipio: "Acand\u00ed",
      id_departamento: "27",
      departamento: "Choc\u00f3"
    },
    {
      id: "27025",
      municipio: "Alto Baud\u00f3",
      id_departamento: "27",
      departamento: "Choc\u00f3"
    },
    {
      id: "27050",
      municipio: "Atrato",
      id_departamento: "27",
      departamento: "Choc\u00f3"
    },
    {
      id: "27073",
      municipio: "Bagad\u00f3",
      id_departamento: "27",
      departamento: "Choc\u00f3"
    },
    {
      id: "27075",
      municipio: "Bah\u00eda Solano",
      id_departamento: "27",
      departamento: "Choc\u00f3"
    },
    {
      id: "27077",
      municipio: "Bajo Baud\u00f3",
      id_departamento: "27",
      departamento: "Choc\u00f3"
    },
    {
      id: "27099",
      municipio: "Bojay\u00e1",
      id_departamento: "27",
      departamento: "Choc\u00f3"
    },
    {
      id: "27135",
      municipio: "El Cant\u00f3n San Pablo",
      id_departamento: "27",
      departamento: "Choc\u00f3"
    },
    {
      id: "27150",
      municipio: "Carmen del Dari\u00e9n",
      id_departamento: "27",
      departamento: "Choc\u00f3"
    },
    {
      id: "27160",
      municipio: "C\u00e9rtegui",
      id_departamento: "27",
      departamento: "Choc\u00f3"
    },
    {
      id: "27205",
      municipio: "Condoto",
      id_departamento: "27",
      departamento: "Choc\u00f3"
    },
    {
      id: "27245",
      municipio: "El Carmen de Atrato",
      id_departamento: "27",
      departamento: "Choc\u00f3"
    },
    {
      id: "27250",
      municipio: "El Litoral San Juan",
      id_departamento: "27",
      departamento: "Choc\u00f3"
    },
    {
      id: "27361",
      municipio: "Istmina",
      id_departamento: "27",
      departamento: "Choc\u00f3"
    },
    {
      id: "27372",
      municipio: "Jurad\u00f3",
      id_departamento: "27",
      departamento: "Choc\u00f3"
    },
    {
      id: "27413",
      municipio: "Llor\u00f3",
      id_departamento: "27",
      departamento: "Choc\u00f3"
    },
    {
      id: "27425",
      municipio: "Medio Atrato",
      id_departamento: "27",
      departamento: "Choc\u00f3"
    },
    {
      id: "27430",
      municipio: "Medio Baud\u00f3",
      id_departamento: "27",
      departamento: "Choc\u00f3"
    },
    {
      id: "27450",
      municipio: "Medio San Juan",
      id_departamento: "27",
      departamento: "Choc\u00f3"
    },
    {
      id: "27491",
      municipio: "N\u00f3vita",
      id_departamento: "27",
      departamento: "Choc\u00f3"
    },
    {
      id: "27495",
      municipio: "Nuqu\u00ed",
      id_departamento: "27",
      departamento: "Choc\u00f3"
    },
    {
      id: "27580",
      municipio: "R\u00edo Ir\u00f3",
      id_departamento: "27",
      departamento: "Choc\u00f3"
    },
    {
      id: "27600",
      municipio: "R\u00edo Quito",
      id_departamento: "27",
      departamento: "Choc\u00f3"
    },
    {
      id: "27615",
      municipio: "Riosucio",
      id_departamento: "27",
      departamento: "Choc\u00f3"
    },
    {
      id: "27660",
      municipio: "San Jos\u00e9 del Palmar",
      id_departamento: "27",
      departamento: "Choc\u00f3"
    },
    {
      id: "27745",
      municipio: "Sip\u00ed",
      id_departamento: "27",
      departamento: "Choc\u00f3"
    },
    {
      id: "27787",
      municipio: "Tad\u00f3",
      id_departamento: "27",
      departamento: "Choc\u00f3"
    },
    {
      id: "27800",
      municipio: "Ungu\u00eda",
      id_departamento: "27",
      departamento: "Choc\u00f3"
    },
    {
      id: "27810",
      municipio: "Uni\u00f3n Panamericana",
      id_departamento: "27",
      departamento: "Choc\u00f3"
    },
    {
      id: "41001",
      municipio: "Neiva",
      id_departamento: "41",
      departamento: "Huila"
    },
    {
      id: "41006",
      municipio: "Acevedo",
      id_departamento: "41",
      departamento: "Huila"
    },
    {
      id: "41013",
      municipio: "Agrado",
      id_departamento: "41",
      departamento: "Huila"
    },
    {
      id: "41016",
      municipio: "Aipe",
      id_departamento: "41",
      departamento: "Huila"
    },
    {
      id: "41020",
      municipio: "Algeciras",
      id_departamento: "41",
      departamento: "Huila"
    },
    {
      id: "41026",
      municipio: "Altamira",
      id_departamento: "41",
      departamento: "Huila"
    },
    {
      id: "41078",
      municipio: "Baraya",
      id_departamento: "41",
      departamento: "Huila"
    },
    {
      id: "41132",
      municipio: "Campoalegre",
      id_departamento: "41",
      departamento: "Huila"
    },
    {
      id: "41206",
      municipio: "Colombia",
      id_departamento: "41",
      departamento: "Huila"
    },
    {
      id: "41244",
      municipio: "El\u00edas",
      id_departamento: "41",
      departamento: "Huila"
    },
    {
      id: "41298",
      municipio: "Garz\u00f3n",
      id_departamento: "41",
      departamento: "Huila"
    },
    {
      id: "41306",
      municipio: "Gigante",
      id_departamento: "41",
      departamento: "Huila"
    },
    {
      id: "41319",
      municipio: "Guadalupe",
      id_departamento: "41",
      departamento: "Huila"
    },
    {
      id: "41349",
      municipio: "Hobo",
      id_departamento: "41",
      departamento: "Huila"
    },
    {
      id: "41357",
      municipio: "\u00cdquira",
      id_departamento: "41",
      departamento: "Huila"
    },
    {
      id: "41359",
      municipio: "Isnos",
      id_departamento: "41",
      departamento: "Huila"
    },
    {
      id: "41378",
      municipio: "La Argentina",
      id_departamento: "41",
      departamento: "Huila"
    },
    {
      id: "41396",
      municipio: "La Plata",
      id_departamento: "41",
      departamento: "Huila"
    },
    {
      id: "41483",
      municipio: "N\u00e1taga",
      id_departamento: "41",
      departamento: "Huila"
    },
    {
      id: "41503",
      municipio: "Oporapa",
      id_departamento: "41",
      departamento: "Huila"
    },
    {
      id: "41518",
      municipio: "Paicol",
      id_departamento: "41",
      departamento: "Huila"
    },
    {
      id: "41524",
      municipio: "Palermo",
      id_departamento: "41",
      departamento: "Huila"
    },
    {
      id: "41530",
      municipio: "Palestina",
      id_departamento: "41",
      departamento: "Huila"
    },
    {
      id: "41548",
      municipio: "Pital",
      id_departamento: "41",
      departamento: "Huila"
    },
    {
      id: "41551",
      municipio: "Pitalito",
      id_departamento: "41",
      departamento: "Huila"
    },
    {
      id: "41615",
      municipio: "Rivera",
      id_departamento: "41",
      departamento: "Huila"
    },
    {
      id: "41660",
      municipio: "Saladoblanco",
      id_departamento: "41",
      departamento: "Huila"
    },
    {
      id: "41668",
      municipio: "San Agust\u00edn",
      id_departamento: "41",
      departamento: "Huila"
    },
    {
      id: "41676",
      municipio: "Santa Mar\u00eda",
      id_departamento: "41",
      departamento: "Huila"
    },
    {
      id: "41770",
      municipio: "Suaza",
      id_departamento: "41",
      departamento: "Huila"
    },
    {
      id: "41791",
      municipio: "Tarqui",
      id_departamento: "41",
      departamento: "Huila"
    },
    {
      id: "41797",
      municipio: "Tesalia",
      id_departamento: "41",
      departamento: "Huila"
    },
    {
      id: "41799",
      municipio: "Tello",
      id_departamento: "41",
      departamento: "Huila"
    },
    {
      id: "41801",
      municipio: "Teruel",
      id_departamento: "41",
      departamento: "Huila"
    },
    {
      id: "41807",
      municipio: "Timan\u00e1",
      id_departamento: "41",
      departamento: "Huila"
    },
    {
      id: "41872",
      municipio: "Villavieja",
      id_departamento: "41",
      departamento: "Huila"
    },
    {
      id: "41885",
      municipio: "Yaguar\u00e1",
      id_departamento: "41",
      departamento: "Huila"
    },
    {
      id: "44001",
      municipio: "Riohacha",
      id_departamento: "44",
      departamento: "La Guajira"
    },
    {
      id: "44035",
      municipio: "Albania",
      id_departamento: "44",
      departamento: "La Guajira"
    },
    {
      id: "44078",
      municipio: "Barrancas",
      id_departamento: "44",
      departamento: "La Guajira"
    },
    {
      id: "44090",
      municipio: "Dibulla",
      id_departamento: "44",
      departamento: "La Guajira"
    },
    {
      id: "44098",
      municipio: "Distracci\u00f3n",
      id_departamento: "44",
      departamento: "La Guajira"
    },
    {
      id: "44110",
      municipio: "El Molino",
      id_departamento: "44",
      departamento: "La Guajira"
    },
    {
      id: "44279",
      municipio: "Fonseca",
      id_departamento: "44",
      departamento: "La Guajira"
    },
    {
      id: "44378",
      municipio: "Hatonuevo",
      id_departamento: "44",
      departamento: "La Guajira"
    },
    {
      id: "44420",
      municipio: "La Jagua del Pilar",
      id_departamento: "44",
      departamento: "La Guajira"
    },
    {
      id: "44430",
      municipio: "Maicao",
      id_departamento: "44",
      departamento: "La Guajira"
    },
    {
      id: "44560",
      municipio: "Manaure",
      id_departamento: "44",
      departamento: "La Guajira"
    },
    {
      id: "44650",
      municipio: "San Juan del Cesar",
      id_departamento: "44",
      departamento: "La Guajira"
    },
    {
      id: "44847",
      municipio: "Uribia",
      id_departamento: "44",
      departamento: "La Guajira"
    },
    {
      id: "44855",
      municipio: "Urumita",
      id_departamento: "44",
      departamento: "La Guajira"
    },
    {
      id: "44874",
      municipio: "Villanueva",
      id_departamento: "44",
      departamento: "La Guajira"
    },
    {
      id: "47001",
      municipio: "Santa Marta",
      id_departamento: "47",
      departamento: "Magdalena"
    },
    {
      id: "47030",
      municipio: "Algarrobo",
      id_departamento: "47",
      departamento: "Magdalena"
    },
    {
      id: "47053",
      municipio: "Aracataca",
      id_departamento: "47",
      departamento: "Magdalena"
    },
    {
      id: "47058",
      municipio: "Ariguan\u00ed",
      id_departamento: "47",
      departamento: "Magdalena"
    },
    {
      id: "47161",
      municipio: "Cerro de San Antonio",
      id_departamento: "47",
      departamento: "Magdalena"
    },
    {
      id: "47170",
      municipio: "Chivolo",
      id_departamento: "47",
      departamento: "Magdalena"
    },
    {
      id: "47189",
      municipio: "Ci\u00e9naga",
      id_departamento: "47",
      departamento: "Magdalena"
    },
    {
      id: "47205",
      municipio: "Concordia",
      id_departamento: "47",
      departamento: "Magdalena"
    },
    {
      id: "47245",
      municipio: "El Banco",
      id_departamento: "47",
      departamento: "Magdalena"
    },
    {
      id: "47258",
      municipio: "El Pi\u00f1\u00f3n",
      id_departamento: "47",
      departamento: "Magdalena"
    },
    {
      id: "47268",
      municipio: "El Ret\u00e9n",
      id_departamento: "47",
      departamento: "Magdalena"
    },
    {
      id: "47288",
      municipio: "Fundaci\u00f3n",
      id_departamento: "47",
      departamento: "Magdalena"
    },
    {
      id: "47318",
      municipio: "Guamal",
      id_departamento: "47",
      departamento: "Magdalena"
    },
    {
      id: "47460",
      municipio: "Nueva Granada",
      id_departamento: "47",
      departamento: "Magdalena"
    },
    {
      id: "47541",
      municipio: "Pedraza",
      id_departamento: "47",
      departamento: "Magdalena"
    },
    {
      id: "47545",
      municipio: "Piji\u00f1o del Carmen",
      id_departamento: "47",
      departamento: "Magdalena"
    },
    {
      id: "47551",
      municipio: "Pivijay",
      id_departamento: "47",
      departamento: "Magdalena"
    },
    {
      id: "47555",
      municipio: "Plato",
      id_departamento: "47",
      departamento: "Magdalena"
    },
    {
      id: "47570",
      municipio: "Puebloviejo",
      id_departamento: "47",
      departamento: "Magdalena"
    },
    {
      id: "47605",
      municipio: "Remolino",
      id_departamento: "47",
      departamento: "Magdalena"
    },
    {
      id: "47660",
      municipio: "Sabanas de San \u00c1ngel",
      id_departamento: "47",
      departamento: "Magdalena"
    },
    {
      id: "47675",
      municipio: "Salamina",
      id_departamento: "47",
      departamento: "Magdalena"
    },
    {
      id: "47692",
      municipio: "San Sebasti\u00e1n de Buenavista",
      id_departamento: "47",
      departamento: "Magdalena"
    },
    {
      id: "47703",
      municipio: "San Zen\u00f3n",
      id_departamento: "47",
      departamento: "Magdalena"
    },
    {
      id: "47707",
      municipio: "Santa Ana",
      id_departamento: "47",
      departamento: "Magdalena"
    },
    {
      id: "47720",
      municipio: "Santa B\u00e1rbara de Pinto",
      id_departamento: "47",
      departamento: "Magdalena"
    },
    {
      id: "47745",
      municipio: "Sitionuevo",
      id_departamento: "47",
      departamento: "Magdalena"
    },
    {
      id: "47798",
      municipio: "Tenerife",
      id_departamento: "47",
      departamento: "Magdalena"
    },
    {
      id: "47960",
      municipio: "Zapay\u00e1n",
      id_departamento: "47",
      departamento: "Magdalena"
    },
    {
      id: "47980",
      municipio: "Zona Bananera",
      id_departamento: "47",
      departamento: "Magdalena"
    },
    {
      id: "50001",
      municipio: "Villavicencio",
      id_departamento: "50",
      departamento: "Meta"
    },
    {
      id: "50006",
      municipio: "Acac\u00edas",
      id_departamento: "50",
      departamento: "Meta"
    },
    {
      id: "50110",
      municipio: "Barranca de Up\u00eda",
      id_departamento: "50",
      departamento: "Meta"
    },
    {
      id: "50124",
      municipio: "Cabuyaro",
      id_departamento: "50",
      departamento: "Meta"
    },
    {
      id: "50150",
      municipio: "Castilla la Nueva",
      id_departamento: "50",
      departamento: "Meta"
    },
    {
      id: "50223",
      municipio: "San Luis de Cubarral",
      id_departamento: "50",
      departamento: "Meta"
    },
    {
      id: "50226",
      municipio: "Cumaral",
      id_departamento: "50",
      departamento: "Meta"
    },
    {
      id: "50245",
      municipio: "El Calvario",
      id_departamento: "50",
      departamento: "Meta"
    },
    {
      id: "50251",
      municipio: "El Castillo",
      id_departamento: "50",
      departamento: "Meta"
    },
    {
      id: "50270",
      municipio: "El Dorado",
      id_departamento: "50",
      departamento: "Meta"
    },
    {
      id: "50287",
      municipio: "Fuente de Oro",
      id_departamento: "50",
      departamento: "Meta"
    },
    {
      id: "50313",
      municipio: "Granada",
      id_departamento: "50",
      departamento: "Meta"
    },
    {
      id: "50318",
      municipio: "Guamal",
      id_departamento: "50",
      departamento: "Meta"
    },
    {
      id: "50325",
      municipio: "Mapirip\u00e1n",
      id_departamento: "50",
      departamento: "Meta"
    },
    {
      id: "50330",
      municipio: "Mesetas",
      id_departamento: "50",
      departamento: "Meta"
    },
    {
      id: "50350",
      municipio: "La Macarena",
      id_departamento: "50",
      departamento: "Meta"
    },
    {
      id: "50370",
      municipio: "Uribe",
      id_departamento: "50",
      departamento: "Meta"
    },
    {
      id: "50400",
      municipio: "Lejan\u00edas",
      id_departamento: "50",
      departamento: "Meta"
    },
    {
      id: "50450",
      municipio: "Puerto Concordia",
      id_departamento: "50",
      departamento: "Meta"
    },
    {
      id: "50568",
      municipio: "Puerto Gait\u00e1n",
      id_departamento: "50",
      departamento: "Meta"
    },
    {
      id: "50573",
      municipio: "Puerto L\u00f3pez",
      id_departamento: "50",
      departamento: "Meta"
    },
    {
      id: "50577",
      municipio: "Puerto Lleras",
      id_departamento: "50",
      departamento: "Meta"
    },
    {
      id: "50590",
      municipio: "Puerto Rico",
      id_departamento: "50",
      departamento: "Meta"
    },
    {
      id: "50606",
      municipio: "Restrepo",
      id_departamento: "50",
      departamento: "Meta"
    },
    {
      id: "50680",
      municipio: "San Carlos de Guaroa",
      id_departamento: "50",
      departamento: "Meta"
    },
    {
      id: "50683",
      municipio: "San Juan de Arama",
      id_departamento: "50",
      departamento: "Meta"
    },
    {
      id: "50686",
      municipio: "San Juanito",
      id_departamento: "50",
      departamento: "Meta"
    },
    {
      id: "50689",
      municipio: "San Mart\u00edn",
      id_departamento: "50",
      departamento: "Meta"
    },
    {
      id: "50711",
      municipio: "Vistahermosa",
      id_departamento: "50",
      departamento: "Meta"
    },
    {
      id: "52001",
      municipio: "Pasto",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52019",
      municipio: "Alb\u00e1n",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52022",
      municipio: "Aldana",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52036",
      municipio: "Ancuy\u00e1",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52051",
      municipio: "Arboleda",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52079",
      municipio: "Barbacoas",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52083",
      municipio: "Bel\u00e9n",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52110",
      municipio: "Buesaco",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52203",
      municipio: "Col\u00f3n",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52207",
      municipio: "Consac\u00e1",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52210",
      municipio: "Contadero",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52215",
      municipio: "C\u00f3rdoba",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52224",
      municipio: "Cuasp\u00fad",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52227",
      municipio: "Cumbal",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52233",
      municipio: "Cumbitara",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52240",
      municipio: "Chachag\u00fc\u00ed",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52250",
      municipio: "El Charco",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52254",
      municipio: "El Pe\u00f1ol",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52256",
      municipio: "El Rosario",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52258",
      municipio: "El Tabl\u00f3n de G\u00f3mez",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52260",
      municipio: "El Tambo",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52287",
      municipio: "Funes",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52317",
      municipio: "Guachucal",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52320",
      municipio: "Guaitarilla",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52323",
      municipio: "Gualmat\u00e1n",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52352",
      municipio: "Iles",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52354",
      municipio: "Imu\u00e9s",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52356",
      municipio: "Ipiales",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52378",
      municipio: "La Cruz",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52381",
      municipio: "La Florida",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52385",
      municipio: "La Llanada",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52390",
      municipio: "La Tola",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52399",
      municipio: "La Uni\u00f3n",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52405",
      municipio: "Leiva",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52411",
      municipio: "Linares",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52418",
      municipio: "Los Andes",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52427",
      municipio: "Mag\u00fc\u00ed",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52435",
      municipio: "Mallama",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52473",
      municipio: "Mosquera",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52480",
      municipio: "Nari\u00f1o",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52490",
      municipio: "Olaya Herrera",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52506",
      municipio: "Ospina",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52520",
      municipio: "Francisco Pizarro",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52540",
      municipio: "Policarpa",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52560",
      municipio: "Potos\u00ed",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52565",
      municipio: "Providencia",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52573",
      municipio: "Puerres",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52585",
      municipio: "Pupiales",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52612",
      municipio: "Ricaurte",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52621",
      municipio: "Roberto Pay\u00e1n",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52678",
      municipio: "Samaniego",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52683",
      municipio: "Sandon\u00e1",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52685",
      municipio: "San Bernardo",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52687",
      municipio: "San Lorenzo",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52693",
      municipio: "San Pablo",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52694",
      municipio: "San Pedro de Cartago",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52696",
      municipio: "Santa B\u00e1rbara",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52699",
      municipio: "Santacruz",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52720",
      municipio: "Sapuyes",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52786",
      municipio: "Taminango",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52788",
      municipio: "Tangua",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52835",
      municipio: "San Andr\u00e9s de Tumaco",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52838",
      municipio: "T\u00faquerres",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "52885",
      municipio: "Yacuanquer",
      id_departamento: "52",
      departamento: "Nari\u00f1o"
    },
    {
      id: "54001",
      municipio: "C\u00facuta",
      id_departamento: "54",
      departamento: "Norte de Santander"
    },
    {
      id: "54003",
      municipio: "\u00c1brego",
      id_departamento: "54",
      departamento: "Norte de Santander"
    },
    {
      id: "54051",
      municipio: "Arboledas",
      id_departamento: "54",
      departamento: "Norte de Santander"
    },
    {
      id: "54099",
      municipio: "Bochalema",
      id_departamento: "54",
      departamento: "Norte de Santander"
    },
    {
      id: "54109",
      municipio: "Bucarasica",
      id_departamento: "54",
      departamento: "Norte de Santander"
    },
    {
      id: "54125",
      municipio: "C\u00e1cota",
      id_departamento: "54",
      departamento: "Norte de Santander"
    },
    {
      id: "54128",
      municipio: "C\u00e1chira",
      id_departamento: "54",
      departamento: "Norte de Santander"
    },
    {
      id: "54172",
      municipio: "Chin\u00e1cota",
      id_departamento: "54",
      departamento: "Norte de Santander"
    },
    {
      id: "54174",
      municipio: "Chitag\u00e1",
      id_departamento: "54",
      departamento: "Norte de Santander"
    },
    {
      id: "54206",
      municipio: "Convenci\u00f3n",
      id_departamento: "54",
      departamento: "Norte de Santander"
    },
    {
      id: "54223",
      municipio: "Cucutilla",
      id_departamento: "54",
      departamento: "Norte de Santander"
    },
    {
      id: "54239",
      municipio: "Durania",
      id_departamento: "54",
      departamento: "Norte de Santander"
    },
    {
      id: "54245",
      municipio: "El Carmen",
      id_departamento: "54",
      departamento: "Norte de Santander"
    },
    {
      id: "54250",
      municipio: "El Tarra",
      id_departamento: "54",
      departamento: "Norte de Santander"
    },
    {
      id: "54261",
      municipio: "El Zulia",
      id_departamento: "54",
      departamento: "Norte de Santander"
    },
    {
      id: "54313",
      municipio: "Gramalote",
      id_departamento: "54",
      departamento: "Norte de Santander"
    },
    {
      id: "54344",
      municipio: "Hacar\u00ed",
      id_departamento: "54",
      departamento: "Norte de Santander"
    },
    {
      id: "54347",
      municipio: "Herr\u00e1n",
      id_departamento: "54",
      departamento: "Norte de Santander"
    },
    {
      id: "54377",
      municipio: "Labateca",
      id_departamento: "54",
      departamento: "Norte de Santander"
    },
    {
      id: "54385",
      municipio: "La Esperanza",
      id_departamento: "54",
      departamento: "Norte de Santander"
    },
    {
      id: "54398",
      municipio: "La Playa",
      id_departamento: "54",
      departamento: "Norte de Santander"
    },
    {
      id: "54405",
      municipio: "Los Patios",
      id_departamento: "54",
      departamento: "Norte de Santander"
    },
    {
      id: "54418",
      municipio: "Lourdes",
      id_departamento: "54",
      departamento: "Norte de Santander"
    },
    {
      id: "54480",
      municipio: "Mutiscua",
      id_departamento: "54",
      departamento: "Norte de Santander"
    },
    {
      id: "54498",
      municipio: "Oca\u00f1a",
      id_departamento: "54",
      departamento: "Norte de Santander"
    },
    {
      id: "54518",
      municipio: "Pamplona",
      id_departamento: "54",
      departamento: "Norte de Santander"
    },
    {
      id: "54520",
      municipio: "Pamplonita",
      id_departamento: "54",
      departamento: "Norte de Santander"
    },
    {
      id: "54553",
      municipio: "Puerto Santander",
      id_departamento: "54",
      departamento: "Norte de Santander"
    },
    {
      id: "54599",
      municipio: "Ragonvalia",
      id_departamento: "54",
      departamento: "Norte de Santander"
    },
    {
      id: "54660",
      municipio: "Salazar",
      id_departamento: "54",
      departamento: "Norte de Santander"
    },
    {
      id: "54670",
      municipio: "San Calixto",
      id_departamento: "54",
      departamento: "Norte de Santander"
    },
    {
      id: "54673",
      municipio: "San Cayetano",
      id_departamento: "54",
      departamento: "Norte de Santander"
    },
    {
      id: "54680",
      municipio: "Santiago",
      id_departamento: "54",
      departamento: "Norte de Santander"
    },
    {
      id: "54720",
      municipio: "Sardinata",
      id_departamento: "54",
      departamento: "Norte de Santander"
    },
    {
      id: "54743",
      municipio: "Silos",
      id_departamento: "54",
      departamento: "Norte de Santander"
    },
    {
      id: "54800",
      municipio: "Teorama",
      id_departamento: "54",
      departamento: "Norte de Santander"
    },
    {
      id: "54810",
      municipio: "Tib\u00fa",
      id_departamento: "54",
      departamento: "Norte de Santander"
    },
    {
      id: "54820",
      municipio: "Toledo",
      id_departamento: "54",
      departamento: "Norte de Santander"
    },
    {
      id: "54871",
      municipio: "Villa Caro",
      id_departamento: "54",
      departamento: "Norte de Santander"
    },
    {
      id: "54874",
      municipio: "Villa del Rosario",
      id_departamento: "54",
      departamento: "Norte de Santander"
    },
    {
      id: "63001",
      municipio: "Armenia",
      id_departamento: "63",
      departamento: "Quindio"
    },
    {
      id: "63111",
      municipio: "Buenavista",
      id_departamento: "63",
      departamento: "Quindio"
    },
    {
      id: "63130",
      municipio: "Calarc\u00e1",
      id_departamento: "63",
      departamento: "Quindio"
    },
    {
      id: "63190",
      municipio: "Circasia",
      id_departamento: "63",
      departamento: "Quindio"
    },
    {
      id: "63212",
      municipio: "C\u00f3rdoba",
      id_departamento: "63",
      departamento: "Quindio"
    },
    {
      id: "63272",
      municipio: "Filandia",
      id_departamento: "63",
      departamento: "Quindio"
    },
    {
      id: "63302",
      municipio: "G\u00e9nova",
      id_departamento: "63",
      departamento: "Quindio"
    },
    {
      id: "63401",
      municipio: "La Tebaida",
      id_departamento: "63",
      departamento: "Quindio"
    },
    {
      id: "63470",
      municipio: "Montenegro",
      id_departamento: "63",
      departamento: "Quindio"
    },
    {
      id: "63548",
      municipio: "Pijao",
      id_departamento: "63",
      departamento: "Quindio"
    },
    {
      id: "63594",
      municipio: "Quimbaya",
      id_departamento: "63",
      departamento: "Quindio"
    },
    {
      id: "63690",
      municipio: "Salento",
      id_departamento: "63",
      departamento: "Quindio"
    },
    {
      id: "66001",
      municipio: "Pereira",
      id_departamento: "66",
      departamento: "Risaralda"
    },
    {
      id: "66045",
      municipio: "Ap\u00eda",
      id_departamento: "66",
      departamento: "Risaralda"
    },
    {
      id: "66075",
      municipio: "Balboa",
      id_departamento: "66",
      departamento: "Risaralda"
    },
    {
      id: "66088",
      municipio: "Bel\u00e9n de Umbr\u00eda",
      id_departamento: "66",
      departamento: "Risaralda"
    },
    {
      id: "66170",
      municipio: "Dosquebradas",
      id_departamento: "66",
      departamento: "Risaralda"
    },
    {
      id: "66318",
      municipio: "Gu\u00e1tica",
      id_departamento: "66",
      departamento: "Risaralda"
    },
    {
      id: "66383",
      municipio: "La Celia",
      id_departamento: "66",
      departamento: "Risaralda"
    },
    {
      id: "66400",
      municipio: "La Virginia",
      id_departamento: "66",
      departamento: "Risaralda"
    },
    {
      id: "66440",
      municipio: "Marsella",
      id_departamento: "66",
      departamento: "Risaralda"
    },
    {
      id: "66456",
      municipio: "Mistrat\u00f3",
      id_departamento: "66",
      departamento: "Risaralda"
    },
    {
      id: "66572",
      municipio: "Pueblo Rico",
      id_departamento: "66",
      departamento: "Risaralda"
    },
    {
      id: "66594",
      municipio: "Quinch\u00eda",
      id_departamento: "66",
      departamento: "Risaralda"
    },
    {
      id: "66682",
      municipio: "Santa Rosa de Cabal",
      id_departamento: "66",
      departamento: "Risaralda"
    },
    {
      id: "66687",
      municipio: "Santuario",
      id_departamento: "66",
      departamento: "Risaralda"
    },
    {
      id: "68001",
      municipio: "Bucaramanga",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68013",
      municipio: "Aguada",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68020",
      municipio: "Albania",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68051",
      municipio: "Aratoca",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68077",
      municipio: "Barbosa",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68079",
      municipio: "Barichara",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68081",
      municipio: "Barrancabermeja",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68092",
      municipio: "Betulia",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68101",
      municipio: "Bol\u00edvar",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68121",
      municipio: "Cabrera",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68132",
      municipio: "California",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68147",
      municipio: "Capitanejo",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68152",
      municipio: "Carcas\u00ed",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68160",
      municipio: "Cepit\u00e1",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68162",
      municipio: "Cerrito",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68167",
      municipio: "Charal\u00e1",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68169",
      municipio: "Charta",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68176",
      municipio: "Chima",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68179",
      municipio: "Chipat\u00e1",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68190",
      municipio: "Cimitarra",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68207",
      municipio: "Concepci\u00f3n",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68209",
      municipio: "Confines",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68211",
      municipio: "Contrataci\u00f3n",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68217",
      municipio: "Coromoro",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68229",
      municipio: "Curit\u00ed",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68235",
      municipio: "El Carmen de Chucur\u00ed",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68245",
      municipio: "El Guacamayo",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68250",
      municipio: "El Pe\u00f1\u00f3n",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68255",
      municipio: "El Play\u00f3n",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68264",
      municipio: "Encino",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68266",
      municipio: "Enciso",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68271",
      municipio: "Flori\u00e1n",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68276",
      municipio: "Floridablanca",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68296",
      municipio: "Gal\u00e1n",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68298",
      municipio: "G\u00e1mbita",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68307",
      municipio: "Gir\u00f3n",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68318",
      municipio: "Guaca",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68320",
      municipio: "Guadalupe",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68322",
      municipio: "Guapot\u00e1",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68324",
      municipio: "Guavat\u00e1",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68327",
      municipio: "G\u00fcepsa",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68344",
      municipio: "Hato",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68368",
      municipio: "Jes\u00fas Mar\u00eda",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68370",
      municipio: "Jord\u00e1n",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68377",
      municipio: "La Belleza",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68385",
      municipio: "Land\u00e1zuri",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68397",
      municipio: "La Paz",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68406",
      municipio: "Lebrija",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68418",
      municipio: "Los Santos",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68425",
      municipio: "Macaravita",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68432",
      municipio: "M\u00e1laga",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68444",
      municipio: "Matanza",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68464",
      municipio: "Mogotes",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68468",
      municipio: "Molagavita",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68498",
      municipio: "Ocamonte",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68500",
      municipio: "Oiba",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68502",
      municipio: "Onzaga",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68522",
      municipio: "Palmar",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68524",
      municipio: "Palmas del Socorro",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68533",
      municipio: "P\u00e1ramo",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68547",
      municipio: "Piedecuesta",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68549",
      municipio: "Pinchote",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68572",
      municipio: "Puente Nacional",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68573",
      municipio: "Puerto Parra",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68575",
      municipio: "Puerto Wilches",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68615",
      municipio: "Rionegro",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68655",
      municipio: "Sabana de Torres",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68669",
      municipio: "San Andr\u00e9s",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68673",
      municipio: "San Benito",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68679",
      municipio: "San Gil",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68682",
      municipio: "San Joaqu\u00edn",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68684",
      municipio: "San Jos\u00e9 de Miranda",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68686",
      municipio: "San Miguel",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68689",
      municipio: "San Vicente de Chucur\u00ed",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68705",
      municipio: "Santa B\u00e1rbara",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68720",
      municipio: "Santa Helena del Op\u00f3n",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68745",
      municipio: "Simacota",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68755",
      municipio: "Socorro",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68770",
      municipio: "Suaita",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68773",
      municipio: "Sucre",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68780",
      municipio: "Surat\u00e1",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68820",
      municipio: "Tona",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68855",
      municipio: "Valle de San Jos\u00e9",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68861",
      municipio: "V\u00e9lez",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68867",
      municipio: "Vetas",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68872",
      municipio: "Villanueva",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "68895",
      municipio: "Zapatoca",
      id_departamento: "68",
      departamento: "Santander"
    },
    {
      id: "70001",
      municipio: "Sincelejo",
      id_departamento: "70",
      departamento: "Sucre"
    },
    {
      id: "70110",
      municipio: "Buenavista",
      id_departamento: "70",
      departamento: "Sucre"
    },
    {
      id: "70124",
      municipio: "Caimito",
      id_departamento: "70",
      departamento: "Sucre"
    },
    {
      id: "70204",
      municipio: "Coloso",
      id_departamento: "70",
      departamento: "Sucre"
    },
    {
      id: "70215",
      municipio: "Corozal",
      id_departamento: "70",
      departamento: "Sucre"
    },
    {
      id: "70221",
      municipio: "Cove\u00f1as",
      id_departamento: "70",
      departamento: "Sucre"
    },
    {
      id: "70230",
      municipio: "Chal\u00e1n",
      id_departamento: "70",
      departamento: "Sucre"
    },
    {
      id: "70233",
      municipio: "El Roble",
      id_departamento: "70",
      departamento: "Sucre"
    },
    {
      id: "70235",
      municipio: "Galeras",
      id_departamento: "70",
      departamento: "Sucre"
    },
    {
      id: "70265",
      municipio: "Guaranda",
      id_departamento: "70",
      departamento: "Sucre"
    },
    {
      id: "70400",
      municipio: "La Uni\u00f3n",
      id_departamento: "70",
      departamento: "Sucre"
    },
    {
      id: "70418",
      municipio: "Los Palmitos",
      id_departamento: "70",
      departamento: "Sucre"
    },
    {
      id: "70429",
      municipio: "Majagual",
      id_departamento: "70",
      departamento: "Sucre"
    },
    {
      id: "70473",
      municipio: "Morroa",
      id_departamento: "70",
      departamento: "Sucre"
    },
    {
      id: "70508",
      municipio: "Ovejas",
      id_departamento: "70",
      departamento: "Sucre"
    },
    {
      id: "70523",
      municipio: "Palmito",
      id_departamento: "70",
      departamento: "Sucre"
    },
    {
      id: "70670",
      municipio: "Sampu\u00e9s",
      id_departamento: "70",
      departamento: "Sucre"
    },
    {
      id: "70678",
      municipio: "San Benito abad",
      id_departamento: "70",
      departamento: "Sucre"
    },
    {
      id: "70702",
      municipio: "San Juan de Betulia",
      id_departamento: "70",
      departamento: "Sucre"
    },
    {
      id: "70708",
      municipio: "San Marcos",
      id_departamento: "70",
      departamento: "Sucre"
    },
    {
      id: "70713",
      municipio: "San Onofre",
      id_departamento: "70",
      departamento: "Sucre"
    },
    {
      id: "70717",
      municipio: "San Pedro",
      id_departamento: "70",
      departamento: "Sucre"
    },
    {
      id: "70742",
      municipio: "San Luis de Sinc\u00e9",
      id_departamento: "70",
      departamento: "Sucre"
    },
    {
      id: "70771",
      municipio: "Sucre",
      id_departamento: "70",
      departamento: "Sucre"
    },
    {
      id: "70820",
      municipio: "Santiago de Tol\u00fa",
      id_departamento: "70",
      departamento: "Sucre"
    },
    {
      id: "70823",
      municipio: "Tol\u00fa Viejo",
      id_departamento: "70",
      departamento: "Sucre"
    },
    {
      id: "73001",
      municipio: "Ibagu\u00e9",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73024",
      municipio: "Alpujarra",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73026",
      municipio: "Alvarado",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73030",
      municipio: "Ambalema",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73043",
      municipio: "Anzo\u00e1tegui",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73055",
      municipio: "Armero ",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73067",
      municipio: "Ataco",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73124",
      municipio: "Cajamarca",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73148",
      municipio: "Carmen de Apical\u00e1",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73152",
      municipio: "Casabianca",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73168",
      municipio: "Chaparral",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73200",
      municipio: "Coello",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73217",
      municipio: "Coyaima",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73226",
      municipio: "Cunday",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73236",
      municipio: "Dolores",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73268",
      municipio: "Espinal",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73270",
      municipio: "Falan",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73275",
      municipio: "Flandes",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73283",
      municipio: "Fresno",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73319",
      municipio: "Guamo",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73347",
      municipio: "Herveo",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73349",
      municipio: "Honda",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73352",
      municipio: "Icononzo",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73408",
      municipio: "L\u00e9rida",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73411",
      municipio: "L\u00edbano",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73443",
      municipio: "San Sebasti\u00e1n de Mariquita",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73449",
      municipio: "Melgar",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73461",
      municipio: "Murillo",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73483",
      municipio: "Natagaima",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73504",
      municipio: "Ortega",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73520",
      municipio: "Palocabildo",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73547",
      municipio: "Piedras",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73555",
      municipio: "Planadas",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73563",
      municipio: "Prado",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73585",
      municipio: "Purificaci\u00f3n",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73616",
      municipio: "Rioblanco",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73622",
      municipio: "Roncesvalles",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73624",
      municipio: "Rovira",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73671",
      municipio: "Salda\u00f1a",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73675",
      municipio: "San Antonio",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73678",
      municipio: "San Luis",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73686",
      municipio: "Santa Isabel",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73770",
      municipio: "Su\u00e1rez",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73854",
      municipio: "Valle de San Juan",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73861",
      municipio: "Venadillo",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73870",
      municipio: "Villahermosa",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "73873",
      municipio: "Villarrica",
      id_departamento: "73",
      departamento: "Tolima"
    },
    {
      id: "76001",
      municipio: "Cali",
      id_departamento: "76",
      departamento: "Valle del Cauca"
    },
    {
      id: "76020",
      municipio: "Alcal\u00e1",
      id_departamento: "76",
      departamento: "Valle del Cauca"
    },
    {
      id: "76036",
      municipio: "Andaluc\u00eda",
      id_departamento: "76",
      departamento: "Valle del Cauca"
    },
    {
      id: "76041",
      municipio: "Ansermanuevo",
      id_departamento: "76",
      departamento: "Valle del Cauca"
    },
    {
      id: "76054",
      municipio: "Argelia",
      id_departamento: "76",
      departamento: "Valle del Cauca"
    },
    {
      id: "76100",
      municipio: "Bol\u00edvar",
      id_departamento: "76",
      departamento: "Valle del Cauca"
    },
    {
      id: "76109",
      municipio: "Buenaventura",
      id_departamento: "76",
      departamento: "Valle del Cauca"
    },
    {
      id: "76111",
      municipio: "Guadalajara de Buga",
      id_departamento: "76",
      departamento: "Valle del Cauca"
    },
    {
      id: "76113",
      municipio: "Bugalagrande",
      id_departamento: "76",
      departamento: "Valle del Cauca"
    },
    {
      id: "76122",
      municipio: "Caicedonia",
      id_departamento: "76",
      departamento: "Valle del Cauca"
    },
    {
      id: "76126",
      municipio: "Calima",
      id_departamento: "76",
      departamento: "Valle del Cauca"
    },
    {
      id: "76130",
      municipio: "Candelaria",
      id_departamento: "76",
      departamento: "Valle del Cauca"
    },
    {
      id: "76147",
      municipio: "Cartago",
      id_departamento: "76",
      departamento: "Valle del Cauca"
    },
    {
      id: "76233",
      municipio: "Dagua",
      id_departamento: "76",
      departamento: "Valle del Cauca"
    },
    {
      id: "76243",
      municipio: "El \u00c1guila",
      id_departamento: "76",
      departamento: "Valle del Cauca"
    },
    {
      id: "76246",
      municipio: "El Cairo",
      id_departamento: "76",
      departamento: "Valle del Cauca"
    },
    {
      id: "76248",
      municipio: "El Cerrito",
      id_departamento: "76",
      departamento: "Valle del Cauca"
    },
    {
      id: "76250",
      municipio: "El Dovio",
      id_departamento: "76",
      departamento: "Valle del Cauca"
    },
    {
      id: "76275",
      municipio: "Florida",
      id_departamento: "76",
      departamento: "Valle del Cauca"
    },
    {
      id: "76306",
      municipio: "Ginebra",
      id_departamento: "76",
      departamento: "Valle del Cauca"
    },
    {
      id: "76318",
      municipio: "Guacar\u00ed",
      id_departamento: "76",
      departamento: "Valle del Cauca"
    },
    {
      id: "76364",
      municipio: "Jamund\u00ed",
      id_departamento: "76",
      departamento: "Valle del Cauca"
    },
    {
      id: "76377",
      municipio: "La Cumbre",
      id_departamento: "76",
      departamento: "Valle del Cauca"
    },
    {
      id: "76400",
      municipio: "La Uni\u00f3n",
      id_departamento: "76",
      departamento: "Valle del Cauca"
    },
    {
      id: "76403",
      municipio: "La Victoria",
      id_departamento: "76",
      departamento: "Valle del Cauca"
    },
    {
      id: "76497",
      municipio: "Obando",
      id_departamento: "76",
      departamento: "Valle del Cauca"
    },
    {
      id: "76520",
      municipio: "Palmira",
      id_departamento: "76",
      departamento: "Valle del Cauca"
    },
    {
      id: "76563",
      municipio: "Pradera",
      id_departamento: "76",
      departamento: "Valle del Cauca"
    },
    {
      id: "76606",
      municipio: "Restrepo",
      id_departamento: "76",
      departamento: "Valle del Cauca"
    },
    {
      id: "76616",
      municipio: "Riofr\u00edo",
      id_departamento: "76",
      departamento: "Valle del Cauca"
    },
    {
      id: "76622",
      municipio: "Roldanillo",
      id_departamento: "76",
      departamento: "Valle del Cauca"
    },
    {
      id: "76670",
      municipio: "San Pedro",
      id_departamento: "76",
      departamento: "Valle del Cauca"
    },
    {
      id: "76736",
      municipio: "Sevilla",
      id_departamento: "76",
      departamento: "Valle del Cauca"
    },
    {
      id: "76823",
      municipio: "Toro",
      id_departamento: "76",
      departamento: "Valle del Cauca"
    },
    {
      id: "76828",
      municipio: "Trujillo",
      id_departamento: "76",
      departamento: "Valle del Cauca"
    },
    {
      id: "76834",
      municipio: "Tulu\u00e1",
      id_departamento: "76",
      departamento: "Valle del Cauca"
    },
    {
      id: "76845",
      municipio: "Ulloa",
      id_departamento: "76",
      departamento: "Valle del Cauca"
    },
    {
      id: "76863",
      municipio: "Versalles",
      id_departamento: "76",
      departamento: "Valle del Cauca"
    },
    {
      id: "76869",
      municipio: "Vijes",
      id_departamento: "76",
      departamento: "Valle del Cauca"
    },
    {
      id: "76890",
      municipio: "Yotoco",
      id_departamento: "76",
      departamento: "Valle del Cauca"
    },
    {
      id: "76892",
      municipio: "Yumbo",
      id_departamento: "76",
      departamento: "Valle del Cauca"
    },
    {
      id: "76895",
      municipio: "Zarzal",
      id_departamento: "76",
      departamento: "Valle del Cauca"
    },
    {
      id: "81001",
      municipio: "Arauca",
      id_departamento: "81",
      departamento: "Arauca"
    },
    {
      id: "81065",
      municipio: "Arauquita",
      id_departamento: "81",
      departamento: "Arauca"
    },
    {
      id: "81220",
      municipio: "Cravo Norte",
      id_departamento: "81",
      departamento: "Arauca"
    },
    {
      id: "81300",
      municipio: "Fortul",
      id_departamento: "81",
      departamento: "Arauca"
    },
    {
      id: "81591",
      municipio: "Puerto Rond\u00f3n",
      id_departamento: "81",
      departamento: "Arauca"
    },
    {
      id: "81736",
      municipio: "Saravena",
      id_departamento: "81",
      departamento: "Arauca"
    },
    {
      id: "81794",
      municipio: "Tame",
      id_departamento: "81",
      departamento: "Arauca"
    },
    {
      id: "85001",
      municipio: "Yopal",
      id_departamento: "85",
      departamento: "Casanare"
    },
    {
      id: "85010",
      municipio: "Aguazul",
      id_departamento: "85",
      departamento: "Casanare"
    },
    {
      id: "85015",
      municipio: "Ch\u00e1meza",
      id_departamento: "85",
      departamento: "Casanare"
    },
    {
      id: "85125",
      municipio: "Hato Corozal",
      id_departamento: "85",
      departamento: "Casanare"
    },
    {
      id: "85136",
      municipio: "La Salina",
      id_departamento: "85",
      departamento: "Casanare"
    },
    {
      id: "85139",
      municipio: "Man\u00ed",
      id_departamento: "85",
      departamento: "Casanare"
    },
    {
      id: "85162",
      municipio: "Monterrey",
      id_departamento: "85",
      departamento: "Casanare"
    },
    {
      id: "85225",
      municipio: "Nunch\u00eda",
      id_departamento: "85",
      departamento: "Casanare"
    },
    {
      id: "85230",
      municipio: "Orocu\u00e9",
      id_departamento: "85",
      departamento: "Casanare"
    },
    {
      id: "85250",
      municipio: "Paz de Ariporo",
      id_departamento: "85",
      departamento: "Casanare"
    },
    {
      id: "85263",
      municipio: "Pore",
      id_departamento: "85",
      departamento: "Casanare"
    },
    {
      id: "85279",
      municipio: "Recetor",
      id_departamento: "85",
      departamento: "Casanare"
    },
    {
      id: "85300",
      municipio: "Sabanalarga",
      id_departamento: "85",
      departamento: "Casanare"
    },
    {
      id: "85315",
      municipio: "S\u00e1cama",
      id_departamento: "85",
      departamento: "Casanare"
    },
    {
      id: "85325",
      municipio: "San Luis de Palenque",
      id_departamento: "85",
      departamento: "Casanare"
    },
    {
      id: "85400",
      municipio: "T\u00e1mara",
      id_departamento: "85",
      departamento: "Casanare"
    },
    {
      id: "85410",
      municipio: "Tauramena",
      id_departamento: "85",
      departamento: "Casanare"
    },
    {
      id: "85430",
      municipio: "Trinidad",
      id_departamento: "85",
      departamento: "Casanare"
    },
    {
      id: "85440",
      municipio: "Villanueva",
      id_departamento: "85",
      departamento: "Casanare"
    },
    {
      id: "86001",
      municipio: "Mocoa",
      id_departamento: "86",
      departamento: "Putumayo"
    },
    {
      id: "86219",
      municipio: "Col\u00f3n",
      id_departamento: "86",
      departamento: "Putumayo"
    },
    {
      id: "86320",
      municipio: "Orito",
      id_departamento: "86",
      departamento: "Putumayo"
    },
    {
      id: "86568",
      municipio: "Puerto As\u00eds",
      id_departamento: "86",
      departamento: "Putumayo"
    },
    {
      id: "86569",
      municipio: "Puerto Caicedo",
      id_departamento: "86",
      departamento: "Putumayo"
    },
    {
      id: "86571",
      municipio: "Puerto Guzm\u00e1n",
      id_departamento: "86",
      departamento: "Putumayo"
    },
    {
      id: "86573",
      municipio: "Puerto Legu\u00edzamo",
      id_departamento: "86",
      departamento: "Putumayo"
    },
    {
      id: "86749",
      municipio: "Sibundoy",
      id_departamento: "86",
      departamento: "Putumayo"
    },
    {
      id: "86755",
      municipio: "San Francisco",
      id_departamento: "86",
      departamento: "Putumayo"
    },
    {
      id: "86757",
      municipio: "San Miguel",
      id_departamento: "86",
      departamento: "Putumayo"
    },
    {
      id: "86760",
      municipio: "Santiago",
      id_departamento: "86",
      departamento: "Putumayo"
    },
    {
      id: "86865",
      municipio: "Valle del Guamuez",
      id_departamento: "86",
      departamento: "Putumayo"
    },
    {
      id: "86885",
      municipio: "Villagarz\u00f3n",
      id_departamento: "86",
      departamento: "Putumayo"
    },
    {
      id: "88001",
      municipio: "San Andr\u00e9s",
      id_departamento: "88",
      departamento: "Archipi\u00e9lago de San Andr\u00e9s Providencia y Santa Catalina"
    },
    {
      id: "88564",
      municipio: "Providencia",
      id_departamento: "88",
      departamento: "Archipi\u00e9lago de San Andr\u00e9s Providencia y Santa Catalina"
    },
    {
      id: "91001",
      municipio: "Leticia",
      id_departamento: "91",
      departamento: "Amazonas"
    },
    {
      id: "91263",
      municipio: "El Encanto",
      id_departamento: "91",
      departamento: "Amazonas"
    },
    {
      id: "91405",
      municipio: "La Chorrera",
      id_departamento: "91",
      departamento: "Amazonas"
    },
    {
      id: "91407",
      municipio: "La Pedrera",
      id_departamento: "91",
      departamento: "Amazonas"
    },
    {
      id: "91430",
      municipio: "La Victoria",
      id_departamento: "91",
      departamento: "Amazonas"
    },
    {
      id: "91460",
      municipio: "Mirit\u00ed Paran\u00e1",
      id_departamento: "91",
      departamento: "Amazonas"
    },
    {
      id: "91530",
      municipio: "Puerto Alegr\u00eda",
      id_departamento: "91",
      departamento: "Amazonas"
    },
    {
      id: "91536",
      municipio: "Puerto Arica",
      id_departamento: "91",
      departamento: "Amazonas"
    },
    {
      id: "91540",
      municipio: "Puerto Nari\u00f1o",
      id_departamento: "91",
      departamento: "Amazonas"
    },
    {
      id: "91669",
      municipio: "Puerto Santander",
      id_departamento: "91",
      departamento: "Amazonas"
    },
    {
      id: "91798",
      municipio: "Tarapac\u00e1",
      id_departamento: "91",
      departamento: "Amazonas"
    },
    {
      id: "94001",
      municipio: "In\u00edrida",
      id_departamento: "94",
      departamento: "Guain\u00eda"
    },
    {
      id: "94343",
      municipio: "Barranco Minas",
      id_departamento: "94",
      departamento: "Guain\u00eda"
    },
    {
      id: "94663",
      municipio: "Mapiripana",
      id_departamento: "94",
      departamento: "Guain\u00eda"
    },
    {
      id: "94883",
      municipio: "San Felipe",
      id_departamento: "94",
      departamento: "Guain\u00eda"
    },
    {
      id: "94884",
      municipio: "Puerto Colombia",
      id_departamento: "94",
      departamento: "Guain\u00eda"
    },
    {
      id: "94885",
      municipio: "La Guadalupe",
      id_departamento: "94",
      departamento: "Guain\u00eda"
    },
    {
      id: "94886",
      municipio: "Cacahual",
      id_departamento: "94",
      departamento: "Guain\u00eda"
    },
    {
      id: "94887",
      municipio: "Pana Pana",
      id_departamento: "94",
      departamento: "Guain\u00eda"
    },
    {
      id: "94888",
      municipio: "Morichal",
      id_departamento: "94",
      departamento: "Guain\u00eda"
    },
    {
      id: "95001",
      municipio: "San Jos\u00e9 del Guaviare",
      id_departamento: "95",
      departamento: "Guaviare"
    },
    {
      id: "95015",
      municipio: "Calamar",
      id_departamento: "95",
      departamento: "Guaviare"
    },
    {
      id: "95025",
      municipio: "El Retorno",
      id_departamento: "95",
      departamento: "Guaviare"
    },
    {
      id: "95200",
      municipio: "Miraflores",
      id_departamento: "95",
      departamento: "Guaviare"
    },
    {
      id: "97001",
      municipio: "Mit\u00fa",
      id_departamento: "97",
      departamento: "Vaup\u00e9s"
    },
    {
      id: "97161",
      municipio: "Carur\u00fa",
      id_departamento: "97",
      departamento: "Vaup\u00e9s"
    },
    {
      id: "97511",
      municipio: "Pacoa",
      id_departamento: "97",
      departamento: "Vaup\u00e9s"
    },
    {
      id: "97666",
      municipio: "Taraira",
      id_departamento: "97",
      departamento: "Vaup\u00e9s"
    },
    {
      id: "97777",
      municipio: "Papunaua",
      id_departamento: "97",
      departamento: "Vaup\u00e9s"
    },
    {
      id: "97889",
      municipio: "Yavarat\u00e9",
      id_departamento: "97",
      departamento: "Vaup\u00e9s"
    },
    {
      id: "99001",
      municipio: "Puerto Carre\u00f1o",
      id_departamento: "99",
      departamento: "Vichada"
    },
    {
      id: "99524",
      municipio: "La Primavera",
      id_departamento: "99",
      departamento: "Vichada"
    },
    {
      id: "99624",
      municipio: "Santa Rosal\u00eda",
      id_departamento: "99",
      departamento: "Vichada"
    },
    {
      id: "99773",
      municipio: "Cumaribo",
      id_departamento: "99",
      departamento: "Vichada"
    }
]
export default municipios